import React, { useEffect, useState } from 'react';
import BatterTable from './BatterTable';
import ballImage from '../../assets/img/icon/ball_icon.png';
import {useCookies} from 'react-cookie';
import dateSetting from '../../utils/dateSetting';
import axios from 'axios';
import _ from 'lodash';
import { flatObject } from '../../utils/flat';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';

function FuturesBatterTableWrapper({title, id, column, profile, season}) {
    const [cookies] = useCookies(['hiball_token']);
    let [pitcherType, setPitcherType] = useState('total');
    let [tableData, setTableData] = useState([]);
    let dateObj = dateSetting();
    const { t } = useTranslation();

    const ballObj = {
        Slider: '슬라이더',
        Forkball: '포크',
        Splitter: '포크',
        Cutter: '커터',
        Curveball: '커브',
        Sinker: '싱커',
        Fastball: '직구',
        ChangeUp: '체인지업',
        Sweeper: '스위퍼',
        Other: '기타'
    }

    useEffect(() => {
        let {playerId} = profile;
        
        let params = {
            batterIds: playerId,
            seasons: season,
            gameTypeCode: 4206,
            authToken:JSON.stringify(cookies['hiball_token']),
            recordType: 'futuresRecordService'
        };

        if(column === 'futuresBallCode') {
            params['recordName'] = 'futuresBatterBallTypeRecord';
        } else { // count
            params['recordName'] = 'futuresBatterCountTypeRecord';
        }

        if(pitcherType !== 'total') {
            if(pitcherType === 'R') {
                params['pitchingForms'] = 801;
                params['pitchingHands'] = 'R';
            } else if(pitcherType === 'L') {
                params['pitchingForms'] = 801;
                params['pitchingHands'] = 'L';
            } else { //side
                params['pitchingForms'] = '802,803,804';
            }
        }

        axios({
            url : `${process.env.REACT_APP_API_URL}`,params
        }).then(result => {
            let innerData = result['data']['result'];

            if(column === 'futuresBallCode') {
                let newArr = _.map(innerData, (item) => {
                    item['type'] = ballObj[item['type']];
                    return flatObject(item);
                })

                setTableData(newArr);
            } else {
                let newArr = _.map(innerData, (item) => {
                    return flatObject(item);
                })

                setTableData(newArr);
            }
        })
    }, [pitcherType]);

    function pitcherTypeHandler(event) {
        let value = event.target.value;
        setPitcherType(value);
    }

    return (
        <>
        <div className="tableBox">
            <div className="tableTitle">
                <img src={ballImage} alt='#'/> {title}
                <span id={id+"_stat"}></span>
            </div>
            <div style={{position:'relative'}} className="table_select_div">
                <div style={{position:'absolute', top:'-40px', right: '10px'}}>
                    <div className="formTitle">{t('pitcherThrows')}</div>
                    <Form.Group onChange={pitcherTypeHandler} style={{display:'inline-block'}}>
                        <Form.Select size="sm">
                            <option value="total">{t('all')}</option>
                            <option value="R">{t('throwRight')}</option>
                            <option value="L">{t('throwLeft')}</option>
                            <option value="S">{t('throwSideOrUnder')}</option>
                        </Form.Select>
                    </Form.Group>
                </div>
            </div>
            <div className="tableDiv">
                <BatterTable data={tableData} column={column}/>
            </div>
        </div>
        </>
    )
}

export default FuturesBatterTableWrapper;